import { computed, Directive, input } from '@angular/core';

type InputType =
    | 'input'
    | 'search'
    | 'select'
    | 'chip'
    | 'readonly'
    | 'date'
    | 'search-filter';

export type InputSize = 'md' | 'sm';

@Directive({
    selector: 'mat-form-field[qpxInput], dd[qpxInput]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxFormFieldInput {
    public readonly variant = input<InputType, InputType | ''>('input', {
        alias: 'qpxInput',
        transform: (value) => value || 'input',
    });

    public readonly size = input<InputSize>('md');

    protected readonly className = computed(() => {
        const variant = this.variant();
        if (variant === 'readonly') {
            return 'text-field-input text-foreground';
        }

        const _classNames = ['qpx-input', this.variant(), this.size()];
        return _classNames.join(' ');
    });
}

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'input[matInput]',
    host: {
        '[attr.id]': 'id()',
    },
})
export class QpxInput {
    public readonly id = input.required<string>();
}
